import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { sendMessageToAdmin } from "../../../actions/chat";
import { useNavigate } from "react-router";
import { getCompanyDashboardAction } from "../../../actions/companyDashboard";
import CompanyAccountDetails from "./components/companyAccountDetails";
import CompanyTable from "../buillionAccount/components/CompanyTable";
import { CAPITAL } from "../../../constants";
import CapitalCard from "../capitalCard";
import ShareHolderCapital from "./components/ShareHolderCapital";
import { getCapitalList } from "../../../actions/capital";

export default function BuillionAccountCompany() {
  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(null);
  const { selectedCompany } = useSelector((state) => state.company);
  const { shareCapital, myInfoShareCapital, sharedCapitalIsApproved, sharedCapitalIsEditApproved, } = useSelector((state) => state.capital);

  useEffect(() => {
    const { id } = selectedCompany
    if (id) {
      dispatch(getCompanyDashboardAction(id));
      dispatch(getCapitalList(id));
    }
  }, [dispatch, selectedCompany]);

  return (
    <>
      {/* {isBrowser && <AddDashboard />} */}
      <CompanyAccountDetails
        isEditing={isEditing}
        setIsEditing={(value) => setIsEditing(value)}
      />
      {/* {isMobile
             && <AddDashboard />} */}
      <div className="row mb-5">
        {/* <div className='col-md-6'>
                    <CashBalance isEditing={isEditing} setIsEditing={(value) => setIsEditing(value)} sendMessageToAdmin={sendMessageToAdminfunc} adminLoader={adminLoader} />
                </div> */}
        {/* <div className='col-md-6'>
                    <CompanyBullionBalance isEditing={isEditing} setIsEditing={(value) => setIsEditing(value)} sendMessageToAdmin={sendMessageToAdminfunc} adminLoader={adminLoader} />
                </div>

                <div className='col-md-6'>
                    <CompanyMetalAllocation isEditing={isEditing} setIsEditing={(value) => setIsEditing(value)} />
                </div> */}
        {/* <div className='col-md-6'>
                    <CompnayProductAllocation isEditing={isEditing} setIsEditing={(value) => setIsEditing(value)} />
                </div> */}

        {/* <div className='col-md-6'>
                    <CompanyProfileLoss isEditing={isEditing} setIsEditing={(value) => setIsEditing(value)} />
                </div> */}
        {/* <div className='col-md-6'>
                    <AllInvites sendMessageToAdmin={sendMessageToAdminfunc} adminLoader={adminLoader} />
                </div> */}
        <div className="col-md-6 mb-md-0 mb-4 mt-4">
          <CapitalCard
            company={selectedCompany}
            capitalType={CAPITAL.shared}
            capital={shareCapital}
            myInfoCapital={myInfoShareCapital}
            capitalIsApproved={sharedCapitalIsApproved}
            capitalIsEditApproved={sharedCapitalIsEditApproved}
            title="Issued share capital"
            subtitle="Share capital amount"
            page='dashboard'
          />
        </div>
        <div className="col-md-6 mb-md-0 mb-4 mt-4">
          <ShareHolderCapital />
          {/* <ShareTable type={HOLDERS_PAGE_TYPE.DASHBOARD} isCompanyDashboard={true} /> */}
        </div>
        {/* <div className="col-md-6">
          <CompanyTable />
        </div> */}
      </div>
    </>
  );
}
